const storePermissions = {
    namespaced: true,
    state: {
        ...createAllPermissions()
    },
    actions: {
        async refresh({ dispatch }) {
            removeStoredPermissions();
            dispatch("load");
        },

        async load({ commit, state }) {

            removeExpiredPermissions();

            var request = getApiRequest(this.state);

            var storedString = localStorage.getItem(getStorageKey(request));
            var storedData = storedString && JSON.parse(storedString);

            if (storedData && permissionKeysMatch(state, storedData.permissions)) {
                commit("setPermissions", storedData);
            } else {
                try {
                  var result = await romeApi.get("/user/permission", request);
                  if (permissionKeysMatch(state, result.permissions)) {
                    commit("setPermissions", { ...request, ...result });
                  } else {
                    setTimeout(() => location.reload(), 5000);
                  }
                } catch (err) {
                  console.log("Error getting permissions");
                }
            }
      },
    },
    mutations: {
        setPermissions(state, data) {
            utils.copyCommonProperties(data.permissions, state);
            data.expires = new Date().getTime() + 5 * 60 * 1000;
            localStorage.setItem(getStorageKey(data), JSON.stringify(data));
        },
    }
}

function permissionKeysMatch(permissions2, permissions1) {
    var keys1 = _.keys(permissions1);
    var keys2 = _.keys(permissions2);

    var difference = _.union(_.difference(keys1, keys2), _.difference(keys2, keys1));

    if (difference.length > 0) {
        console.error("Permissions mismatch: " + difference.join(","));
    }

    return difference.length == 0;
}

function getApiRequest(state) {
    var employerId = state.route.employerId || null;
    var participantId = state.route.participantId || null;

    if (employerId == "null") employerId = null;
    if (participantId == "null") participantId = null;

    return {
        entityId: employerId || participantId,
        entityType: employerId ? "employer" : participantId ? "participant" : null,
        userId: (state.session.impersonatedUser && state.session.impersonatedUser.userId)
                || (state.session.user && state.session.user.userId)
    };
}

var lastCleanupTime = null;

function removeExpiredPermissions() {
    const cleanupInterval = 30 * 1000;

    if (lastCleanupTime && (new Date().getTime() - lastCleanupTime) < cleanupInterval) return;

    lastCleanupTime = new Date().getTime();

    var expiredKeys = _.chain(localStorage)
                        .keys()
                        .filter(k => {
                            if (!k.includes("amf:permissions")) return false;
                            var permissionObject = JSON.parse(localStorage.getItem(k));
                            return !permissionObject.expires || (new Date().getTime() - permissionObject.expires) > 0;
                        })
                        .value();
    expiredKeys.forEach(k => localStorage.removeItem(k));
}

function removeStoredPermissions() {
    var keys = _.chain(localStorage)
                        .keys()
                        .filter(k => k.includes("amf:permissions"))
                        .value();
    keys.forEach(k => localStorage.removeItem(k));
}

function getStorageKey(data) {
    return `amf:permissions-${data.userId}-${data.entityType || "none"}-${data.entityId || "none"}`;
}

function createAllPermissions() {
    let state = {};

    let permissions = [
        "createEmployer",
        "viewEmployer",
        "editEmployer",
        "editEmployerAmfCode",
        "editEmployerContact",
        "editEmployerOpr",
        "viewEmployerOpr",
        "viewWorkflowStatus",
        "editWorkflowStatus",
        "manageWorkflowReminders",
        "viewContractFees",
        "viewAllUsers",
        "createUser",
        "editEmployerMyPlanConnect",
        "runPersephoneSync",
        "downloadMidYearEnrollment",
        "uploadMidYearEnrollment",
        "viewHsaFunding",
        "downloadPlanDocument",

        "createParticipant",
        "viewParticipant",
        "editParticipant",
        "terminateParticipant",
        "reactivateParticipant",

        "createDependent",
        "editDependent",
        "terminateDependent",

        "editParticipantCopays",
        "editCalendar",
        "editCard",
        "assignEmployerBroker",
        "deleteEmployerBroker",
        "impersonateUser",
        "signEmployerContract",
        "customizeTermsAndConditions",
        "viewCalendar",
        "viewEmployer",
        "editEmployer",
        "viewEmployerHistory",
        "viewParticipantHistory",
        "viewInvoiceDetails",
        "viewInvoiceTotals",
        "viewAccountBalanceReports",
        "viewDeactivationReports",
        "viewPlan",
        "editPlan",
        "deletePlan",
        "deleteBankTransfer",
        "viewAllPlanFundingTypes",
        "editCustomEligibilityRule",
        "editAccount",
        "editEffectiveDate",
        "viewTransaction",
        "viewTransactionDetails",
        "viewTransactionHistory",
        "createHsaFundingRequest",
        "editEmployerInteraction",
        "editParticipantInteraction",
        "editEmployeeNote",
        "editEmployerNote",
        "viewEmployerNotes",
        "viewParticipantNotes",
        "viewRepayment",
        "viewLegacyFundingOptions",
        "editFundingPercentages",
        "viewLegacySettlementTypes",
        "viewDocRecords",
        "assignEmployerSpecialist",
        "generateRenewal",
        "terminateEmployer",
        "editSelfServiceAccess",
        "viewEmployerPartner",
        "editEmployerPartner",
        "deleteUploadedDocuments",

        "editCobraPolicy",
        "editCobraPoint",
        "exportToCobraPoint",
        "createRateWorkflows",

        "editBroker",
        "createBroker",
        "editAgency",
        "createAgency",
        "editPartner",
        "createPartner",
        "viewEpop",

        "viewEdi",
        "editEdi",
        "viewEdiReports",

        "editEnrollment",

        "viewFunding",
        "editFundingType",
        "editBankAccount",
        "resendCheck",
        "addEmployerCrossSell",
        "cancelCard",
        "editFees",
        "viewEmployerMiscellaneous",
        "createMyPlanConnectCarriers",
        "editTeam",
        "requestQuote",
        "useCommandLine",
        "viewAdminInvoices",
        "runRenewals",
        "convertToFirstData",
        "changeCipStatus",
        "editIssues",
        "bulkUpdateTransactions",
        "uploadAccountTransactions",
        "uploadSecureFiles",
        "assignBrokerSpecialist",
        "viewHsaAccountNumbersReport",
        "downloadCurrentEnrollmentsSpreadsheet",
        "generateRealtimeAndDailyAccountBalanceReport",
        "manuallyAdjustHsa",
        "generateHsaTaxForms",
        "viewTeamStats",
      "editClaimRejectionCodes",
      "downloadParticipantTransactions",
      "hsaAccountTransfer",
        "calculateAffordability",
        "cancelEmployerContract",
        "createInsuranceQuotes"
    ];

    let cobraPermissions = [
        "viewCobraLifeEvent",
        "editCobraLifeEvent",
        "makeCobraElections",
        "viewCobraInvoices",
        "viewCobraRemittanceReport",
        "viewCobra",
        "editCobra",
        "sendCobraLetters",
        "makeCobraPayment"
    ]

    permissions.concat(cobraPermissions).forEach(p => {
        state[p] = false;
    });

    return state;
}

export default storePermissions;



// WEBPACK FOOTER //
// ./src/framework/utils/x-permissions.js